import { css } from 'emotion';

export const lineStyles = css`
	font-size: 16px;
	border-radius: 2px;
	margin-bottom: 2px;
	padding: 8px 24px;
	background-color: white;
`;

export const headerRow = css`
	font-size: 16px;
	border-radius: 2px;
	margin-top: 24px;
	margin-bottom: 2px;
	padding: 8px 24px;
`;
